import React, { useMemo } from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { gradesByIdAtom } from 'shared/api/grades'
import { keyTest } from 'shared/utils'
import { ItemSelect } from './ItemSelect'
import { Box } from '@mui/material'

export function GradeDisplay<T extends { id: number }>({
  item,
  columnData: { key: gradeKey },
}: {
  item: T
  columnData: { key: string }
}) {
  const gradesById = useAtomValue(gradesByIdAtom)
  if (!keyTest(item, gradeKey)) return <Box />
  const gradeId = Number(item[gradeKey])
  const grade = gradesById[gradeId]
  if (!grade) return <Box />
  return <Box>{`${gradeId}: ${grade.name}`}</Box>
}

export function GradeEdit<T extends { id: number }>({
  item,
  columnData: { key: gradeKey, setKey },
}: {
  item: T
  columnData: { key: string; setKey?: string }
}) {
  const hasKey = keyTest(item, gradeKey)
  const gradeId = hasKey ? Number(item[gradeKey]) : undefined
  return <GradeSelect initialGradeId={gradeId} setKey={setKey ?? gradeKey} />
}

function GradeSelect({
  initialGradeId,
  setKey,
}: {
  initialGradeId?: number
  setKey: string
}) {
  const gradesById = useAtomValue(gradesByIdAtom)
  const grade =
    initialGradeId && initialGradeId in gradesById && gradesById[initialGradeId]
  const grades = useMemo(() => {
    return Object.values(gradesById)
  }, [gradesById])

  return (
    <ItemSelect
      initialItem={grade || undefined}
      setKey={setKey}
      items={grades}
      itemDisplay={(item) => item?.name ?? ''}
    />
  )
}
